import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import Background from "../../components/Background";
import Container from "../../components/Container";
import { SnackbarProvider, useSnackbar } from 'notistack';
import Header from "../../components/Header";
import Axios from "axios";
import style from "./Integracao.module.css";
import SubmitButton from "../../components/Button";
import moment from 'moment';
import { useEffect } from 'react';

const Integracao = () => {
    const [idCarregamento, setIdCarregamento] = useState("");
    const [pesoCarregado, setPesoCarregado] = useState("");
    const { enqueueSnackbar } = useSnackbar();
    const usuario = JSON.parse(localStorage.getItem("user_token")).id;
    const [quantidadeBigBag, setQuantidadeBigBag] = useState("");

    const handleSubmit = () => {
        // Arredondar o valor de pesoCarregado para a dezena mais próxima
        const valorArredondado = Math.round(parseFloat(pesoCarregado) / 10) * 10;

        const data = {
            ID_CARREGAMENTO: idCarregamento,
            PESO_CARREGADO_PY: isNaN(valorArredondado) ? "" : valorArredondado,
            DATA_CARREGAMENTO_PY: moment().format('YYYY-MM-DD HH:mm:ss'),
            USUARIO_CARREG_PY: usuario
        };

        Axios.post('https://operacao.setlogistica.com.br/api/integracao', data)
            .then(response => {
                enqueueSnackbar('Dados inseridos com sucesso!', { variant: 'success' });
                setTimeout(() => {
                    window.location.reload();
                }, 1500); // 1.5 segundos de espera antes da recarga
            })
            .catch(error => {
                enqueueSnackbar('Erro ao inserir dados!', { variant: 'error' });
                console.log("Erro ao inserir dados:", error);
            });
    };

    useEffect(() => {
        const quantidade = parseInt(quantidadeBigBag);
        if (!isNaN(quantidade)) {
            setPesoCarregado((quantidade * 1000).toString());
        }
    }, [quantidadeBigBag]);


    return (
        <>
            <Navbar relatorioCliente />
            <Header />
            <Background />
            <Container>
                <div className={style.content}>
                    <div className={style.container1}>
                        <div className={style.dados}>
                            <div className={`${style.form_control} ${style.icon_input}`}>
                                <label>ID Carregamento:</label>
                                <div className={style.input_container}>
                                    <input
                                        type="text"
                                        value={idCarregamento}
                                        onChange={(e) => setIdCarregamento(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className={`${style.form_control} ${style.icon_input}`}>
                                <label>Peso Carregado:</label>
                                <div className={style.input_container}>
                                    <input
                                        type="text"
                                        value={pesoCarregado}
                                        onChange={(e) => setPesoCarregado(e.target.value)}
                                        disabled={!isNaN(parseInt(quantidadeBigBag))} // desativa se Big Bag tiver valor
                                    />
                                </div>
                            </div>

                            <div className={`${style.form_control} ${style.icon_input}`}>
                                <label>Quantidade de Big Bags:</label>
                                <div className={style.input_container}>
                                    <input
                                        type="number"
                                        value={quantidadeBigBag}
                                        onChange={(e) => setQuantidadeBigBag(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className={style.submit_button}>
                                <SubmitButton text={'Inserir'} onClick={handleSubmit} />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default function IntegrationNotistack() {
    return (
        <SnackbarProvider
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            maxSnack={3}
            autoHideDuration={2500}>
            <Integracao />
        </SnackbarProvider>
    );
}
